import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const createQuoteRequest = (payload) =>
  api.post("/quote-requests", payload).then((r) => r.data);

export const listQuoteRequests = (params = {}) =>
  api.get("/quote-requests", { params }).then((r) => r.data);

export const updateQuoteStatus = (id, status) =>
  api.patch(`/quote-requests/${id}`, { status }).then((r) => r.data);

export const getStats = () => api.get("/stats").then((r) => r.data);
